export default __webpack_public_path__ + "static/media/error-4.1b3de8d0.svg";